<script>
import QuoteSlider from './Part/QuoteSlider.vue';

export default {
    data() {
        return {
            data: {},
            togglePassword: false
        };
    },
    components: {
        QuoteSlider
    },
    mounted() {
        var vm = this;

        vm.create();
    },
    methods: {
        create() {
            var vm = this;

            vm.createEmptyData();
        },
        createEmptyData() {
            var vm = this;

            var data = {
                email: null,
                password: null,
            };

            vm.data = Object.assign({}, data);
        },
        _createPostData(data) {
            return data;
        },
        async submit() {
            var vm = this;

            try {
                vm.$loading.on('login_submit');

                var data = vm._createPostData(vm.data);

                var resp = await vm.$api.Auth.login(data);
                vm.$api.setApiToken(resp.data.data.access_token);

                if (resp.data.data.is_email_verified == 1) {
                    vm.$router.push({
                        name: 'verify-session',
                        query: vm.$route.query
                    });
                } else {
                    vm.$router.push({
                        name: 'verify-email',
                    });
                }

            } catch (error) {
                console.log(error);
                vm.$flash.error(error.response.data.message);
            }

            vm.$loading.off('login_submit');
        },
    }
}
</script>

<template>
    <div class="auth-page-wrapper auth-bg-cover py-5 d-flex justify-content-center align-items-center min-vh-100">
        <div class="bg-overlay"></div>
        <div class="auth-page-content overflow-hidden pt-lg-5">
            <BContainer>
                <BRow>
                    <BCol lg="12">
                        <BCard no-body class="overflow-hidden">
                            <BRow class="g-0">
                                <BCol lg="6">
                                    <QuoteSlider />
                                </BCol>

                                <BCol lg="6">
                                    <div class="p-lg-5 p-4">
                                        <div>
                                            <h5 class="text-primary">{{ $t("signin.label.title") }}</h5>
                                            <p class="text-muted">{{ $t("signin.label.sub_title") }}</p>
                                        </div>

                                        <div class="mt-4">
                                            <form action="#" role="form" v-on:submit.prevent="submit()">

                                                <div class="mb-3">
                                                    <label for="email" class="form-label">{{ $t("signin.label.email")
                                                        }}</label>
                                                    <input type="text" class="form-control" id="email"
                                                        :placeholder="$t('signin.placeholder.email')"
                                                        v-model="data.email">
                                                </div>

                                                <div class="mb-3">
                                                    <div class="float-end">
                                                        <router-link :to="{ name: 'forgot-password' }"
                                                            class="text-muted">{{
                                                                $t("signin.label.forget") }}</router-link>
                                                    </div>
                                                    <label class="form-label" for="password-input">{{
                                                        $t("signin.label.password") }}</label>
                                                    <div class="position-relative auth-pass-inputgroup mb-3">
                                                        <input :type="togglePassword ? 'text' : 'password'"
                                                            class="form-control pe-5"
                                                            :placeholder="$t('signin.placeholder.password')"
                                                            id="password-input" v-model="data.password">
                                                        <BButton variant="link"
                                                            class="position-absolute end-0 top-0 text-decoration-none text-muted shadow-none"
                                                            type="button" id="password-addon"
                                                            @click="togglePassword = !togglePassword"><i
                                                                class="ri-eye-fill align-middle"></i></BButton>
                                                    </div>
                                                </div>

                                                <div class="mt-4">
                                                    <BButton variant="primary" class="w-100" type="submit"
                                                        :disabled="$loading.get('login_submit')">
                                                        <loading :loading="$loading.get('login_submit')">
                                                            {{ $t("signin.btn.signin") }}
                                                        </loading>
                                                    </BButton>
                                                </div>

                                            </form>
                                        </div>

                                        <div class="mt-5 text-center">
                                            <p class="mb-0">{{ $t("signin.label.signup") }} <router-link
                                                    :to="{ name: 'signup' }"
                                                    class="fw-semibold text-primary text-decoration-underline"> {{
                                                        $t("signin.btn.signup") }}
                                                </router-link>
                                            </p>
                                        </div>
                                    </div>
                                </BCol>
                            </BRow>
                        </BCard>
                    </BCol>
                </BRow>
            </BContainer>
        </div>

        <footer class="footer">
            <BContainer>
                <BRow>
                    <BCol lg="12">
                        <div class="text-center">
                            <p class="mb-0">&copy; 2026 Cafeman. Seluruh Hak Cipta Dilindungi.</p>
                        </div>
                    </BCol>
                </BRow>
            </BContainer>
        </footer>
    </div>
</template>